<template>
  <div class="flex flex-col items-center">
    <div class="m-2">
      <h1 class="font-bold text-5xl my-4">Limited Editions</h1>
    </div>
    <div class="flex flex-col mt-2 mx-4 w-full md:w-3/5 mb-8">
        <p class="mt-2 mb-8 block">
            We're happy to introduce Fantom Wheelz LIMITED EDITION NFT's -
            <br /><br />
            The limited edition ones will NOT be available through minting, but only through auctions or the rare giveaway/airdrop. All the limited edition NFT's will include a 30x30cm / 11x11" signed canvas print of the NFT to the original buyer/receiver (worldwide shipping!).
            
        </p>

        <div class="mt-2 flex flex-row flex-wrap">
          <div class="w-1/2">
            <img src="https://fantomwheelz.com/assets/images/zubawu_vrx_by_SELLEK_01.png" />
          </div>
          <div class="w-1/2">
            <img src="https://fantomwheelz.com/assets/images/blankko_limited_edition_01.png" />
          </div>
          <div class="w-1/2">
            <img src="https://fantomwheelz.com/assets/images/blankko_limited_edition_01.png" />
          </div>
          <div class="w-1/2">
            <img src="https://fantomwheelz.com/assets/images/blankko_limited_edition_fade_01.png" />
          </div>
        </div>

    </div>

  </div>
</template>

<script>
export default {
  props: { },
  components: {}
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/LimitedEditionsPage.vue